import React, { FunctionComponent } from "react";

const ErrorComponent: FunctionComponent = () => {
    return <div>Error </div>;
};

export default ErrorComponent;
